// Quick toure icons and images
import carIconUrl from "@/assets/icons/home/quick-tour/car.svg";
import carsIconUrl from "@/assets/icons/home/quick-tour/cars.svg";
import imageIndividUrl from "@/assets/images/home/quick-tour/fleet-individ-lg.png";
import imageFleetUrl from "@/assets/images/home/quick-tour/fleet-group-lg.png";

// Why trackmate icons
import squareIconUrl from "@/assets/icons/home/whyTrack/square.svg";
import globeIconUrl from "@/assets/icons/home/whyTrack/globe.svg";
import puzzleIconUrl from "@/assets/icons/home/whyTrack/puzzle_piece.svg";
import shieldIconUrl from "@/assets/icons/home/whyTrack/shield.svg";

// Features icons
import check_iconUrl from "@/assets/icons/home/features/check-list.svg?react";
import notification_iconUrl from "@/assets/icons/home/features/notification.svg?react";
import report_iconUrl from "@/assets/icons/home/features/report.svg?react";
import transmission_iconUrl from "@/assets/icons/home/features/transmission.svg?react";
import { FEATURES, ROUTES } from "../navigation";

export const quickTourTabs = [
  {
    iconUrl: carIconUrl,
    title: "For Individuals",
    description:
      "Trackmate is the ideal solution to ensure the safety of the people you love most. Real-time tracking protects against theft and tracks vehicle health to maximize the value of your investment.",
    imageUrl: imageIndividUrl,
  },
  {
    iconUrl: carsIconUrl,
    title: "For Fleets",
    description:
      "Whether you're optimizing operational efficiency or safeguarding valuable assets, our platform is your gateway to a seamless and intuitive fleet management experience.",
    imageUrl: imageFleetUrl,
  },
];

export const whyTrackmateCards = [
  {
    iconUrl: squareIconUrl,
    title: "Advanced GPS Technology",
    description: "Trackmate leverages the most advanced M2M, IoT, and telematics technologies.",
  },
  {
    iconUrl: globeIconUrl,
    title: "User-Friendly Interface",
    description:
      "Trackmate’s features are accessible through a user-friendly interface that anyone can master.",
  },
  {
    iconUrl: shieldIconUrl,
    title: "Real-Time Visibility ",
    description: "24/7 real-time tracking and remote control means you’re always in complete control of your assets.",
  },
  {
    iconUrl: puzzleIconUrl,
    title: "Customizable to Your Preferences",
    description:
      "Tailor Trackmate features, alerts, and user experience to meet your precise needs.",
  },
];

export const planDescription = [
  "Satisfaction guaranteed",
  "No contracts or commitments",
  "No hidden fees",
  "Lifetime device support",
  "Security and compliance built-in",
];

export const features = [
  {
    Icon: transmission_iconUrl,
    title: "Telematics",
    content: [
      "Real-time location",
      "User access control",
      "Remote vehicle control",
      "Fleet management",
      "Geofences",
      "Shared link",
    ],
    path: `${ROUTES.features}?feature=${FEATURES.telematics}`,
  },
  {
    Icon: check_iconUrl,
    title: "Compliance",
    content: [
      "Policy adherence tracking",
      "Regulatory reporting",
      "Standards enforcement",
      "Compliance dashboard",
      "Compliance audit trail",
    ],
    path: `${ROUTES.features}?feature=${FEATURES.compliance}`,
  },
  {
    Icon: notification_iconUrl,
    title: "Alerts",
    content: [
      "Real-time alerts",
      "Customizable alert settings",
      "Incident alerts",
      "Instant notification system",
      "Proactive notifications",
    ],
    path: `${ROUTES.features}?feature=${FEATURES.alerts}`,
  },
  {
    Icon: report_iconUrl,
    title: "Reports",
    content: [
      "Performance insights",
      "Actionable insights",
      "Customizable analytics",
      "Analytics dashboard",
      "Data visualization",
      "Reporting tools",
    ],
    path: `${ROUTES.features}?feature=${FEATURES.reports}`,
  },
];

export const metrics = [
  "Location",
  "Speed",
  "Mileage and Fuel",
  "Geofence",
  "Battery health",
  "Emergency Alerts",
  "Data Accuracy",
];

export const homeReviews = [
  {
    title: "Gareth Jones — Founder and CEO of Headstart",
    description: `“I've been using Trackmate for my fleet management needs, and it has truly exceeded my expectations. The level of precision and real-time insights I get is unmatched. The customizable dashboard allows me to focus on the metrics that matter most to my business.”`,
  },
  {
    title: "Gareth Smith — Founder and CEO of Head",
    description: `“I've been using Trackmate for my fleet management needs, and it has truly exceeded my expectations. The level of precision and real-time insights I get is unmatched. The customizable dashboard allows me to focus on the metrics that matter most to my business.”`,
  },
  {
    title: "Smith Jones — Founder and CEO of Start",
    description: `“I've been using Trackmate for my fleet management needs, and it has truly exceeded my expectations. The level of precision and real-time insights I get is unmatched. The customizable dashboard allows me to focus on the metrics that matter most to my business.”`,
  },
  {
    title: "Gareth Jones — Founder and CEO of Headstart",
    description: `“I've been using Trackmate for my fleet management needs, and it has truly exceeded my expectations. The level of precision and real-time insights I get is unmatched. The customizable dashboard allows me to focus on the metrics that matter most to my business.”`,
  },
  {
    title: "Gareth Smith — Founder and CEO of Head",
    description: `“I've been using Trackmate for my fleet management needs, and it has truly exceeded my expectations. The level of precision and real-time insights I get is unmatched. The customizable dashboard allows me to focus on the metrics that matter most to my business.”`,
  },
  {
    title: "Smith Jones — Founder and CEO of Start",
    description: `“I've been using Trackmate for my fleet management needs, and it has truly exceeded my expectations. The level of precision and real-time insights I get is unmatched. The customizable dashboard allows me to focus on the metrics that matter most to my business.”`,
  },
];
